/* eslint-disable react/no-array-index-key */
import React from 'react';
import { node } from 'prop-types';
import { propTypes } from '../../util/types';
import { createSlug } from '../../util/urlHelpers';
import { ensureListing, ensureUser } from '../../util/data';
import { getPackageImages } from '../../util/listing';
import { ResponsiveImage, NamedLink, UserCard } from '..';

import css from './BookingListingBreakdownSection.module.css';

const TransactionUserCard = ({ breakdown, listing, error, packageInfo, currentUser }) => {
  const currentListing = ensureListing(listing);
  const currentAuthor = ensureUser(currentListing.author);
  const listingTitle = currentListing.attributes.title;
  const packagesImages = getPackageImages(currentListing, packageInfo?.id);
  const firstImage = packagesImages?.length > 0 ? packagesImages[0] : currentListing.images[0];
  const params = {
    id: currentListing.id.uuid,
    slug: createSlug(listingTitle),
    packageId: packageInfo?.id,
  };

  const backToListing = (
    <NamedLink
      className={css.detailsTitle}
      name={packageInfo ? 'PackagePage' : 'ListingPage'}
      params={params}
    >
      <h1 className={css.detailsTitle}>{packageInfo ? packageInfo.title : listingTitle}</h1>
    </NamedLink>
  );

  return (
    <div data-testId="booking-listing-section">
      <div className={css.imageWrapper}>
        <ResponsiveImage
          rootClassName={css.image}
          alt={listingTitle}
          image={firstImage}
          variants={['facebook', 'scaled-large']}
        />
      </div>

      <div className={css.listingTitle}>{backToListing}</div>

      <div className={css.authorWrapper}>
        <UserCard
          landowner={currentAuthor}
          currentUser={currentUser}
          fullProfile={false}
          noBio
          avatarClassName={css.avatar}
        />
      </div>
      {error}
      {breakdown}
    </div>
  );
};

TransactionUserCard.defaultProps = {
  breakdown: null,
  error: null,
};

TransactionUserCard.propTypes = {
  breakdown: node,
  listing: propTypes.listing.isRequired,
  error: node,
};

export default TransactionUserCard;
